import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import PersonIcon from '@material-ui/icons/Person';
import ListIcon from '@material-ui/icons/List';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import StarsIcon from '@material-ui/icons/Stars';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  paper: {
    flexGrow: 1,
    padding: theme.spacing(2),
    display: 'flex',
    flexFlow: 'column',
  },
  icon: {
    fontSize: 100,
    color: '#607d8b',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
  },
  leftCol: {
    textAlign: 'center',
  },
  rightCol: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexFlow: 'column',
    padding: theme.spacing(2),
  },
  input: {
    flexGrow: 1,
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(4),
    flexGrow: 1,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
  },
});

class UserDetails extends Component {
  state = {
    askDeldlgOpen: false,
    showPassword: false,
    clientOpen: false,
    clients: [],
    driverOpen: false,
    drivers: [],
  };

  componentDidMount() {
  // Fetch clients list for dialog
  fetch(this.props.appState.appRoutine.apiUrl + 'agents/listactive', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(res => res.json())
      .then(res => {
        let clientsArr = Array.isArray(res) ? res : (res.result || []);
        if (clientsArr.length > 0) {
          this.setState({ clients: clientsArr });
        }
      });
  
  // Fetch drivers list for dialog
  fetch(this.props.appState.appRoutine.apiUrl + 'drivers/list', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(res => res.json())
      .then(res => {
        let driversArr = Array.isArray(res) ? res : (res.result || []);
        if (driversArr.length > 0) {
          this.setState({ drivers: driversArr });
        }
      });
  }
  generatePassword = () => {
    const password = Array.from({ length: 8 }, () => Math.floor(Math.random() * 10)).join('');
    this.props.appState.user.PASS = password;
    this.forceUpdate();
  };

  handleCopyPassword = () => {
    const password = this.props.appState.user.PASS || '';
    if (navigator.clipboard) {
      navigator.clipboard.writeText(password);
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = password;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  };
  handleSave = () => {
    const user = this.props.appState.user;
    const route = user.ID === 0 ? 'users/insert' : 'users/update';
    fetch(this.props.appState.appRoutine.apiUrl + route, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(user),
    })
      .then(res => res.json())
      .then(() => {
        this.props.reload();
        this.props.appState.appRoutine.msg = {
          text: 'Saved',
          open: true,
          type: 'success',
        };
      });
  };

  handleDelete = () => {
    fetch(this.props.appState.appRoutine.apiUrl + 'users/delete', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ID: this.props.appState.user.ID }),
    })
      .then(res => res.json())
      .then(() => {
        this.props.reload();
        this.props.appState.user = {};
        this.props.appState.appRoutine.msg = {
          text: 'Deleted',
          open: true,
          type: 'success',
        };
      });
    this.setState({ askDeldlgOpen: false });
  };

  render() {
    const { classes, appState } = this.props;
    return (
      <div>
        <Paper className={classes.paper}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={4} className={classes.leftCol}>
              <PersonIcon className={classes.icon} />
            </Grid>
            <Grid item xs={12} sm={12} md={8} className={classes.rightCol}>
              <div style={{display: 'flex'}}>
                <TextField
                  label="Name"
                  variant="outlined"
                  className={classes.input}
                  style={{flexGrow: 1}}
                  value={appState.user.NAME || ''}
                  onChange={e => {
                    appState.user.NAME = e.target.value;
                    this.forceUpdate();
                  }}
                />
                <Button
                  variant="outlined"
                  style={{
                    height: 55,
                    flexShrink: 1,
                    marginLeft: 5,
                    marginTop: 16,
                    backgroundColor: (appState.user.ROLE === 'Driver' || appState.user.ROLE === 'Client') ? '' : '#f5f5f5',
                    color: (appState.user.ROLE === 'Driver' || appState.user.ROLE === 'Client') ? '' : '#bdbdbd',
                    cursor: (appState.user.ROLE === 'Driver' || appState.user.ROLE === 'Client') ? 'pointer' : 'not-allowed',
                    borderColor: (appState.user.ROLE === 'Driver' || appState.user.ROLE === 'Client') ? '' : '#e0e0e0',
                  }}
                  onClick={()=>{
                    if (appState.user.ROLE === 'Driver') {
                      this.setState({driverOpen: true});
                    } else {
                      this.setState({clientOpen: true});
                    }
                  }}
                  disabled={appState.user.ROLE !== 'Driver' && appState.user.ROLE !== 'Client'}
                >
                  <ListIcon style={{color: (appState.user.ROLE === 'Driver' || appState.user.ROLE === 'Client') ? '#607d8b' : '#bdbdbd', fontSize: 26}}/>
                </Button>
              </div>
              <TextField
                label="Login"
                variant="outlined"
                className={classes.input}
                value={appState.user.LOGIN || ''}
                onChange={e => {
                  appState.user.LOGIN = e.target.value;
                  this.forceUpdate();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="Copy login">
                        <IconButton
                          aria-label="Copy login"
                          onClick={() => {
                            const login = appState.user.LOGIN || '';
                            if (navigator.clipboard) {
                              navigator.clipboard.writeText(login);
                            } else {
                              const textarea = document.createElement('textarea');
                              textarea.value = login;
                              document.body.appendChild(textarea);
                              textarea.select();
                              document.execCommand('copy');
                              document.body.removeChild(textarea);
                            }
                          }}
                          edge="end"
                          style={{ color: '#888' }}
                        >
                          <FileCopyIcon />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Password"
                variant="outlined"
                className={classes.input}
                value={appState.user.PASS || ''}
                onChange={e => {
                  appState.user.PASS = e.target.value;
                  this.forceUpdate();
                }}
                type={this.state.showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title={this.state.showPassword ? 'Hide password' : 'Show password'}>
                        <IconButton
                          aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
                          onClick={() => this.setState({ showPassword: !this.state.showPassword })}
                          edge="end"
                          style={{ color: '#888' }}
                        >
                          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Generate password">
                        <IconButton
                          aria-label="Generate password"
                          onClick={this.generatePassword}
                          edge="end"
                          style={{ color: '#888' }}
                        >
                          <StarsIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Copy password">
                        <IconButton
                          aria-label="Copy password"
                          onClick={this.handleCopyPassword}
                          edge="end"
                          style={{ color: '#888' }}
                        >
                          <FileCopyIcon />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
              <Grid container spacing={2} style={{ marginTop: 16 }}>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                  <Select
                    variant="outlined"
                    fullWidth
                    value={appState.user.ROLE || 'Agent'}
                    onChange={e => {
                      appState.user.ROLE = e.target.value;
                      this.forceUpdate();
                    }}
                    displayEmpty
                  >
                    <MenuItem value="Admin">Admin</MenuItem>
                    <MenuItem value="Client">Client</MenuItem>
                    <MenuItem value="Driver">Driver</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} style={{ display: 'flex', alignItems: 'center' }}>
                  <FormControlLabel
                    style={{ padding: 8, marginLeft: 5 }}
                    control={
                      <Switch
                        checked={appState.user.STATUS === 'Active'}
                        onChange={e => {
                          appState.user.STATUS = e.target.checked ? 'Active' : 'Inactive';
                          this.forceUpdate();
                        }}
                        color="primary"
                      />
                    }
                    label="Active"
                  />
                </Grid>
              </Grid>
              <div className={classes.buttons}>
                <IconButton
                  color="primary"
                  aria-label="Delete"
                  style={{ margin: 10 }}
                  onClick={() => this.setState({ askDeldlgOpen: true })}
                >
                  <DeleteIcon />
                </IconButton>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ margin: 10, float: 'right' }}
                  startIcon={<SaveIcon />}
                  onClick={this.handleSave}
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
        <Dialog
          open={this.state.askDeldlgOpen}
          onClose={() => this.setState({ askDeldlgOpen: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete User?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm you really want to delete this user.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ askDeldlgOpen: false })} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleDelete} color="primary" autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.clientOpen}
          onClose={() => this.setState({ clientOpen: false })}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-slide-title">{"Select Client"}</DialogTitle>
          <DialogContent dividers style={{textAlign: 'center'}}>
            <List component="nav" className={classes.list}>
              {(Array.isArray(this.state.clients) ? this.state.clients : [])
                .sort((a, b) => {
                  var nameA = (a.NAME || '').toLowerCase(), nameB = (b.NAME || '').toLowerCase();
                  if (nameA < nameB) return -1;
                  if (nameA > nameB) return 1;
                  return 0;
                })
                .map((item, index) => (
                  <ListItem button key={index} onClick={() => {
                    this.props.appState.user.NAME = item.NAME;
                    this.props.appState.user.LOGIN = item.EMAIL || '';
                    this.setState({ clientOpen: false });
                    this.forceUpdate();
                  }}>
                    <ListItemText primary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body1"
                          className={classes.inline}
                          color={item.STATUS === 'Active' ? 'textPrimary' : 'textSecondary'}
                        >
                          {item.NAME}
                        </Typography>
                      </React.Fragment>
                    }/>
                  </ListItem>
                ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ clientOpen: false })} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.driverOpen}
          onClose={() => this.setState({ driverOpen: false })}
          aria-labelledby="alert-dialog-driver-title"
          aria-describedby="alert-dialog-driver-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-driver-title">{"Select Driver"}</DialogTitle>
          <DialogContent dividers style={{textAlign: 'center'}}>
            <List component="nav" className={classes.list}>
              {(Array.isArray(this.state.drivers) ? this.state.drivers : [])
                .filter(item => item.STATUS === 'Active')
                .sort((a, b) => {
                  var nameA = (a.SURNAME || '').toLowerCase(), 
                      nameB = (b.SURNAME || '').toLowerCase();
                  if (nameA < nameB) return -1;
                  if (nameA > nameB) return 1;
                  return 0;
                })
                .map((item, index) => (
                  <ListItem button key={index} onClick={() => {
                    this.props.appState.user.NAME = item.SURNAME || '';
                    this.props.appState.user.LOGIN = item.EMAIL || '';
                    this.setState({ driverOpen: false });
                    this.forceUpdate();
                  }}>
                    <ListItemText primary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body1"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {item.SURNAME || ''}
                        </Typography>
                      </React.Fragment>
                    }/>
                  </ListItem>
                ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ driverOpen: false })} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(UserDetails);
